module.exports = __webpack_public_path__ + "img/72771e5.png";